import React from "react";
import "./contactAndMediaComponent.scss";
import SocialMediaIcons from "./socialMediaIcons";
import ContactMethod from "./contactMethodComponent";
import { FaMapMarkerAlt } from "react-icons/fa";
import { MdPhoneIphone } from "react-icons/md";

const ContactAndMedia = () => {
  return (
    <div className="contact-and-media-container">
      <div className="contact-methods-container">
        <ContactMethod
          icon={FaMapMarkerAlt}
          text={
            "Arthur Evelyn Building, Suite 5, Main Street, Charlestown, Nevis"
          }
        />
        <ContactMethod icon={MdPhoneIphone} text={"+381-60-3335726"} />
      </div>
      <div className="contact-methods-container">
        info@cubeglobalservices.com
      </div>
    </div>
  );
};

export default ContactAndMedia;
